<script lang="ts">
/**
 *
 * @usage Provide a maxlength prop to display the character count.
 *
 */

export default {
  inheritAttrs: false,
};
</script>

<script lang="ts" setup>
import { ref, computed, ComputedRef } from 'vue';

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  modelValue: {
    type: String,
    default: '',
  },
  maxlength: String,
});

const modelValue = ref(props.modelValue);
const remaining: ComputedRef<Number> = computed(() => {
  if (!props.maxlength) return 0; // In case a maxlength prop isn't provided
  if (modelValue.value) {
    return parseInt(props.maxlength) - modelValue.value.length;
  }
  return parseInt(props.maxlength);
});
</script>

<template>
  <label class="mb-2 block" v-if="label">{{ label }}</label>
  <input
    v-bind="$attrs"
    v-model="modelValue"
    @input="$emit('update:modelValue', modelValue)"
    class="appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none"
    :maxlength="props.maxlength ?? ''"
  />
  <div
    v-if="props.maxlength && remaining < 100"
    class="pt-2 text-right text-xs font-medium"
    :class="[remaining < 10 ? 'text-red-600' : 'text-teal-600']"
  >
    {{ remaining }} characters remaining
  </div>
</template>
